import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class StdStandardService {
  // 获取协议下拉数据
  static async getProtocolType() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/CollectDataSourceConfig/get-protocol-type')
    )
    return Callback(err, res)
  }
  // 获取数据源列表
  static async getCollectDataSourceConfigList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CollectDataSourceConfig?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增配置
  static async addCollectDataSourceConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CollectDataSourceConfig', payload)
    )
    return Callback(err, res)
  }
  // 获取配置详情
  static async getCollectDataSourceConfigDetail(id) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/CollectDataSourceConfig/${id}`))
    return Callback(err, res)
  }
  // 编辑配置保存
  static async updateCollectDataSourceConfig(id, payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/CollectDataSourceConfig/${id}`, payload)
    )
    return Callback(err, res)
  }
  // 批量删除配置
  static async batchDeleteConfig(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/CollectDataSourceConfig/many', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 修改操作状态
  static async updateCollectStatus(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CollectDataSourceConfig/update-collect-status', payload)
    )
    return Callback(err, res)
  }
  // 监控测点提醒配置保存
  static async saveEmailMonitorPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/CollectDataSourceConfig/save-email-monitor-point', payload)
    )
    return Callback(err, res)
  }
  // 获取监控测点提醒配置详情
  static async getEmailMonitorPoint(id) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/CollectDataSourceConfig/get-email-monitor-point/${id}`)
    )
    return Callback(err, res)
  }
  // 获取测点列表
  static async getMeasuringpointList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 批量设置监控测点
  static async setMonitorPoint(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/CollectDataSourceConfig/measuringpoint/set-monitor-point',
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取OpcHda列表
  static async getListHistory(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-list-history?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 数据补采
  static async collectHistoryData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/collect-history-data?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
  // 数据补采进度
  static async getCollectHistoryDataProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/CollectDataSourceConfig/measuringpoint/get-collect-history-data-progress?${qs.stringify(
          payload
        )}`
      )
    )
    return Callback(err, res)
  }
}
